import store from '../store';

export default ({next, router}) => {
    if(!store.state.user.user_id){
        return router.push({name: 'home'});
    }

    return next();
};